module.exports = __webpack_public_path__ + "media/images/certificate/white_80_pct-c51e0127cb0ed86c5fa70e7d9e3c8409.png";